import Model from './Model'
import { ListingsService } from '@/service'

export enum ListingType {
  COURSE = 'Course',
  COMMUNITY = 'Community',
}

export enum ListingCategory {
  BUSINESS = 'Business',
  HEALTH_FITNESS = 'HealthFitness',
}
export enum ListingStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum ListingMembershipType {
  FREE = 'Free',
  PAID = 'Paid',
}

export enum ListingAccessType {
  PUBLIC = 'Public',
  PRIVATE = 'Private',
}

export interface IListing {
  _id?: string
  marketplaceLocationId: string
  type: ListingType
  slug: string
  locationId: string
  externalId: string
  name: string
  description: string
  membersCount: number
  coverImage: string
  logo: string
  rank: number
  category: ListingCategory
  status: ListingStatus
  discoveryStatus: boolean
  membershipType: ListingMembershipType
  accessType: ListingAccessType
  createdAt?: Date
  updatedAt?: Date
}

export default class Listings extends Model {
  constructor(payload: IListing) {
    super(payload, ListingsService)
  }
}